// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3k-zk","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2Pghe","gfeWrapper":"CalendarEvent_gfeWrapper__2ZQnm"};